import React, { useContext, useState } from 'react';
import { Navbar, NavbarBrand, Nav, NavItem, NavbarToggler, Collapse } from 'reactstrap';
import { useHistory } from 'react-router-dom';

// local imports
import Logo from '../../assets/UW_Horizontal_Logo_Full.png';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

const PsychometricTestMainNavbar = () => {
    const { theme, fontFamily } = useContext(ThemeContext);
    const history = useHistory();
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => setIsOpen(!isOpen);

    const navButtonStyle = {
        textDecoration: 'none',
        color: '#70B646',
        border: 'none',
        background: 'none',
        padding: '8px 16px',
        fontSize: 'clamp(0.8rem, 1vw + 0.5rem, 1rem)',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        whiteSpace: 'nowrap',
        outline: 'none',
        ':focus': {
            outline: 'none',
            textDecoration: 'underline'
        },
        ':active': {
            outline: 'none'
        },
        ':hover': {
            color: '#558f35'
        }
    };

    return (
        <Navbar 
            id="psychometric-main-navbar" 
            color="white" 
            light 
            expand="md" 
            style={{ 
                fontFamily: fontFamily.primary,
                padding: '1rem'
            }}
        >
            <div className="container-fluid d-flex justify-content-between align-items-center">
                <NavbarBrand className="p-0" href="/">
                    <img 
                        id="brand-logo" 
                        style={{ 
                            maxWidth: "160px", 
                            height: "auto", 
                            border: "none", 
                            margin: "0" 
                        }} 
                        src={Logo} 
                        alt="Umang Logo" 
                    />
                </NavbarBrand>
                
                <NavbarToggler onClick={toggle} className="ms-auto" />
                
                <Collapse isOpen={isOpen} navbar className="flex-grow-0">
                    <Nav navbar className="align-items-center">
                        <NavItem>
                            <button 
                                onClick={() => history.push('/psychometricManagementPortal')}
                                style={navButtonStyle}
                            >
                                Account Management
                            </button>
                        </NavItem>
                        <NavItem>
                            <button 
                                onClick={() => history.push('/psychometricAbout')}
                                style={navButtonStyle}
                            >
                                About
                            </button>
                        </NavItem>
                        <NavItem>
                            <button 
                                onClick={() => history.push('/contact')}
                                style={navButtonStyle}
                            >
                                Contact Us
                            </button>
                        </NavItem>
                    </Nav>
                </Collapse>
            </div>
        </Navbar>
    );
}

export default PsychometricTestMainNavbar;
